'use client';

import { Slider } from '@base-ui/react/slider';
import clsx from 'clsx';

import '@repo/sds/components/SDSSlider/SDSSlider.scss';

export interface SliderMark {
  value: number;
  label: string;
}

export interface SDSSliderProps {
  ariaLabel?: string;
  value: number;
  onChange?: (value: number) => void;
  min: number;
  max: number;
  step?: number;
  marks?: SliderMark[];
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}

export function SDSSlider({
  ariaLabel,
  value,
  onChange,
  min,
  max,
  step = 1,
  marks,
  disabled = false,
  className,
  dataTestId,
}: SDSSliderProps) {
  const containerClass = clsx('SDSSlider__container', className);

  const handleValueChange = (newValue: number | readonly number[]) => {
    const finalValue = Array.isArray(newValue) ? newValue[0] : newValue;
    onChange?.(finalValue);
  };

  const sliderValue = Array.isArray(value) ? value : [value];

  return (
    <div className={containerClass}>
      <Slider.Root
        className="SDSSlider"
        data-testid={dataTestId}
        value={sliderValue}
        onValueChange={handleValueChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      >
        <Slider.Control className="SDSSlider__control">
          <Slider.Track className="SDSSlider__track">
            <Slider.Indicator className="SDSSlider__indicator" />
          </Slider.Track>
          <Slider.Thumb className="SDSSlider__thumb" aria-label={ariaLabel} />
        </Slider.Control>
      </Slider.Root>

      {marks && (
        <div className="SDSSlider__marks">
          {marks.map(mark => {
            const percentage = ((mark.value - min) / (max - min)) * 100;
            return (
              <div key={mark.value} className="SDSSlider__mark" style={{ left: `${percentage}%` }}>
                <span className="SDSSlider__mark-label">{mark.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
